import RangeField from './component';

export default RangeField;
